import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-ios-update-notice',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  template: `
    <div class="ios-update-notice">
      <div class="ios-update-container">
        <div class="ios-update-icon">
          <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
              fill="#007AFF"
            />
          </svg>
        </div>
        <h1 class="ios-update-title">{{ 'iosUpdateTitle' | translate }}</h1>
        <p class="ios-update-message">
          {{ 'iosUpdateMessage' | translate: { currentVersion: currentVersion, minVersion: minSupportedVersion } }}
        </p>
        <div class="ios-update-instructions">
          <h3>{{ 'iosUpdateInstructionsTitle' | translate }}</h3>
          <ol>
            <li>{{ 'iosUpdateStep1' | translate }}</li>
            <li>{{ 'iosUpdateStep2' | translate }}</li>
            <li>{{ 'iosUpdateStep3' | translate }}</li>
          </ol>
        </div>
        <div class="ios-update-footer">
          <p class="ios-update-note">
            {{ 'iosUpdateNote' | translate: { minVersion: minSupportedVersion } }}
          </p>
        </div>
      </div>
    </div>
  `,
  styles: [
    `
      .ios-update-notice {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 9999;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
      }

      .ios-update-container {
        background: white;
        border-radius: 20px;
        padding: 40px;
        max-width: 500px;
        width: 90%;
        text-align: center;
        box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
        margin: 20px;
        max-height: 90vh;
        overflow-y: auto;
      }

      .ios-update-icon {
        margin-bottom: 24px;
      }

      .ios-update-title {
        font-size: 28px;
        font-weight: 700;
        color: #1d1d1f;
        margin: 0 0 16px 0;
        line-height: 1.2;
      }

      .ios-update-message {
        font-size: 18px;
        color: #6e6e73;
        margin: 0 0 32px 0;
        line-height: 1.5;
      }

      .ios-update-instructions {
        background: #f5f5f7;
        border-radius: 12px;
        padding: 24px;
        margin: 0 0 24px 0;
        text-align: left;
      }

      .ios-update-instructions h3 {
        font-size: 18px;
        font-weight: 600;
        color: #1d1d1f;
        margin: 0 0 16px 0;
      }

      .ios-update-instructions ol {
        margin: 0;
        padding-left: 20px;
      }

      .ios-update-instructions li {
        font-size: 16px;
        color: #6e6e73;
        margin-bottom: 8px;
        line-height: 1.4;
      }

      .ios-update-instructions strong {
        color: #1d1d1f;
        font-weight: 600;
      }

      .ios-update-footer {
        border-top: 1px solid #e5e5e7;
        padding-top: 20px;
      }

      .ios-update-note {
        font-size: 14px;
        color: #86868b;
        margin: 0;
        line-height: 1.4;
      }

      /* Responsive design for tablets (iPad, etc.) */
      @media (max-width: 1024px) and (min-width: 769px) {
        .ios-update-container {
          max-width: 600px;
          padding: 35px;
          margin: 15px;
          max-height: 85vh;
        }

        .ios-update-title {
          font-size: 26px;
        }

        .ios-update-message {
          font-size: 17px;
        }

        .ios-update-instructions {
          padding: 22px;
        }

        .ios-update-instructions h3 {
          font-size: 17px;
        }

        .ios-update-instructions li {
          font-size: 15px;
        }
      }

      /* iPad landscape orientation */
      @media (max-width: 1024px) and (min-width: 769px) and (orientation: landscape) {
        .ios-update-container {
          max-width: 700px;
          padding: 30px;
          margin: 10px;
          max-height: 90vh;
        }

        .ios-update-title {
          font-size: 24px;
          margin-bottom: 12px;
        }

        .ios-update-message {
          font-size: 16px;
          margin-bottom: 24px;
        }

        .ios-update-instructions {
          padding: 20px;
          margin-bottom: 20px;
        }
      }

      /* Responsive design for mobile devices */
      @media (max-width: 768px) {
        .ios-update-container {
          padding: 30px 20px;
          margin: 10px;
          max-width: 95%;
        }

        .ios-update-title {
          font-size: 24px;
        }

        .ios-update-message {
          font-size: 16px;
        }

        .ios-update-instructions {
          padding: 20px;
        }

        .ios-update-instructions h3 {
          font-size: 16px;
        }

        .ios-update-instructions li {
          font-size: 14px;
        }
      }

      /* Extra small mobile devices */
      @media (max-width: 480px) {
        .ios-update-container {
          padding: 25px 15px;
          margin: 5px;
          border-radius: 15px;
        }

        .ios-update-title {
          font-size: 22px;
        }

        .ios-update-message {
          font-size: 15px;
        }

        .ios-update-instructions {
          padding: 18px;
          border-radius: 10px;
        }

        .ios-update-instructions h3 {
          font-size: 15px;
        }

        .ios-update-instructions li {
          font-size: 13px;
        }
      }

      /* Dark mode support */
      @media (prefers-color-scheme: dark) {
        .ios-update-container {
          background: #1c1c1e;
          color: #ffffff;
        }

        .ios-update-title {
          color: #ffffff;
        }

        .ios-update-message {
          color: #8e8e93;
        }

        .ios-update-instructions {
          background: #2c2c2e;
        }

        .ios-update-instructions h3 {
          color: #ffffff;
        }

        .ios-update-instructions li {
          color: #8e8e93;
        }

        .ios-update-instructions strong {
          color: #ffffff;
        }

        .ios-update-footer {
          border-top-color: #3a3a3c;
        }

        .ios-update-note {
          color: #8e8e93;
        }
      }
    `,
  ],
})
export class IosUpdateNoticeComponent {
  @Input() currentVersion: string = '';
  @Input() minSupportedVersion: string = '16.0';
}
